export class AudioDevice {
    constructor() {
        this.audioStream = null;
        this.closed = false;
        this.track = null;
    }
    _close(audioStream) {
        if (!audioStream) {
            return;
        }
        audioStream.getTracks().forEach(function (track) {
            track.stop();
            audioStream.removeTrack(track);
        });
    }
    close() {
        if (this.closed) {
            return;
        }
        this.closed = true;
        this._close(this.audioStream);
        this.audioStream = null;
    }
    open(audioRtpSender, callback) {
        if (this.closed) {
            return;
        }
        const that = this;
        console.log("open audio media device");
        navigator.mediaDevices.getUserMedia({ video: false, audio: true })
            .then(async (stream) => {
            console.log("open audio media stream", stream);
            // close old and current stream
            if (that.closed) {
                that._close(stream);
                return;
            }
            for (const track of stream.getTracks()) {
                console.log("get audio media track", track);
                await audioRtpSender.replaceTrack(track);
                // close old and current stream
                if (that.closed) {
                    that._close(stream);
                    return;
                }
                callback(true);
            }
            that.audioStream = stream;
        })
            .catch(function (reason) {
            const errorMessage = reason instanceof Error ? reason.message : String(reason);
            console.error("open audio media device error", errorMessage);
            that.close();
            callback(false, reason);
        });
    }
    //Test: maybe multiple RTCRtpSender use the same track
    async bind(audioRtpSender, callback) {
        if (this.closed) {
            return;
        }
        if (this.audioStream && this.audioStream.getTracks().length > 0) {
            await audioRtpSender.replaceTrack(this.audioStream.getTracks()[0]);
            if (this.closed) {
                return;
            }
            callback(true);
        }
        else {
            navigator.mediaDevices.getUserMedia({ video: false, audio: true })
                .then(async (stream) => {
                if (this.closed) {
                    stream.getTracks().forEach(track => track.stop());
                    return;
                }
                const track = stream.getTracks()[0];
                console.log("get audio media track", track);
                if (track && track.kind === "audio") {
                    await audioRtpSender.replaceTrack(track);
                    if (this.closed) {
                        stream.getTracks().forEach(track => track.stop());
                        return;
                    }
                    this.audioStream = stream;
                    callback(true);
                }
                else {
                    callback(false, "failed to start audio device");
                }
            })
                .catch((reason) => {
                const errorMessage = reason instanceof Error ? reason.message : String(reason);
                console.error("open audio media device error", errorMessage);
                this.close();
                callback(false, reason);
            });
        }
    }
}
